import React, { FC } from "react";
import { classNames } from "../../../../../utils/common/styling";
import { styles } from "./SectionCTAContent.styles";
import {
  extractEmojiAndText,
  setOpacity,
  getTextFromReactNode,
} from "../../../../../utils/common/common";
import { CHAT_WITH, DEFAULT_BG_COLOR } from "../../Sidebar.constants";

interface ISectionCTAContentProps {
  label: any;
  icon?: any;
  active?: boolean;
  labelClassName?: string;
  labelStyle?: React.CSSProperties;
  theme?: any;
}

export const SectionCTAContent: FC<ISectionCTAContentProps> = ({
  label,
  icon,
  active,
  labelClassName,
  labelStyle,
  theme,
}) => {
  // Auto-derive icon if not provided
  let derivedIcon = icon;
  let derivedLabel = label;

  if (!icon) {
    const extractedText = getTextFromReactNode(label);

    if (extractedText) {
      const { emoji, text } = extractEmojiAndText(extractedText);

      if (emoji) {
        derivedIcon = emoji;
        derivedLabel = text;
      } else if (extractedText.toLowerCase().startsWith(CHAT_WITH)) {
        derivedIcon = "💬";
      }
    }
  }

  const renderIcon = () => {
    if (!derivedIcon) return null;

    return (
      <div
        className={styles.iconWrapper}
        style={{
          backgroundColor: theme?.colors?.color1
            ? setOpacity(theme.colors.color1, 0.1)
            : DEFAULT_BG_COLOR,
        }}
      >
        <div>
          {typeof derivedIcon === "string" ? (
            <span>{derivedIcon}</span>
          ) : (
            derivedIcon
          )}
        </div>
      </div>
    );
  };

  const renderLabel = () => {
    const labelContent =
      typeof derivedLabel === "string" ? derivedLabel : derivedLabel;

    return (
      <span
        className={classNames(
          styles.label,
          active ? styles.labelActive : styles.labelInactive,
          labelClassName,
        )}
        style={{
          ...labelStyle,
          color: active ? theme?.colors?.color1 : "#000",
        }}
      >
        {labelContent}
      </span>
    );
  };

  return (
    <>
      {renderIcon()}
      <div style={{ flex: 1 }}>{renderLabel()}</div>
    </>
  );
};
